import { UntypedFormGroup, ValidationErrors } from "@angular/forms";

export function matchingInputsValidator(firstKey: string, secondKey: string) {
  return function (group: UntypedFormGroup): ValidationErrors | undefined {
    if (group.controls[firstKey].value !== group.controls[secondKey].value) {
      return {
        missmatch: true,
      };
    }
  };
}
